<template>
  <a-card
    :bordered="true"
    class="header-solid h-full"
    :bodyStyle="{ paddingTop: 0, paddingBottom: '16px' }"
    :loading="loading"
  >
    <template v-if="withTitle" #title>
      <h4 class="m-text-header-thin m-remove">{{ title }}</h4>
    </template>
    <template slot="extra" class="mb-0">
      <!-- <a-button type="primary"> VIEW ALL </a-button> -->
    </template>
    <Pie
      :chart-options="chartOptions"
      :chart-data="chartData"
      :chart-id="chartId"
      :style="customStyle"
    />
  </a-card>
</template>

<script>
import { Pie } from "vue-chartjs/legacy";

import {
  Chart as ChartJS,
  Title,
  Tooltip,
  Legend,
  ArcElement,
  CategoryScale
} from "chart.js";

ChartJS.register(Title, Tooltip, Legend, ArcElement, CategoryScale);

export default {
  name: "PieChart",
  components: {
    Pie
  },
  props: {
    chartId: {
      type: String,
      default: "pie-chart"
    },
    title: {
      type: String
    },
    chartData: {
      type: Object,
      default: () => ({
        labels: [],
        datasets: []
      })
    },
    customStyle: {
      type: Object,
      default: () => ({
        position: "relative",
        "min-height": "200px"
      })
    },
    withTitle: {
      type: Boolean,
      default: () => true
    },
    loading: {
      type: Boolean,
      default: () => false
    }
  },
  data() {
    return {
      chartOptions: {
        responsive: true,
        maintainAspectRatio: false,
        plugins: {
          legend: {
            position: "bottom"
          }
          // title: {
          //   display: this.title ? true : false,
          //   text: this.title,
          //   font: {
          //     size: 20
          //   }
          // }
        }
      }
    };
  }
};
</script>
